var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9814 12C23.9814 18.3513 18.8327 23.5 12.4814 23.5C6.13017 23.5 0.981445 18.3513 0.981445 12C0.981445 5.64873 6.13017 0.5 12.4814 0.5C18.8327 0.5 23.9814 5.64873 23.9814 12Z",
    stroke: "#2A3790"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2963 9.324H12.7963V8.824V6.44375V6.15039H12.1673V6.44375V8.824V9.324H11.6673H7.19029H6.63075L6.456 9.72238V17.8527H18.5073V9.72238L18.3326 9.324H17.7693H13.2963ZM7.58894 17.266H7.08894V16.766V15.1753V14.6753H7.58894H11.6673H12.1673V15.1753V16.766V17.266H11.6673H7.58894Z",
    fill: "#2A3790",
    stroke: "#2A3790"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.dcd0edcdb43a23d4b7080df91150b75e.svg";
export { ForwardRef as ReactComponent };